import { render, staticRenderFns } from "./VideoCarousel.vue?vue&type=template&id=1b0e4bc4&scoped=true"
import script from "./VideoCarousel.vue?vue&type=script&lang=js"
export * from "./VideoCarousel.vue?vue&type=script&lang=js"
import style0 from "./VideoCarousel.vue?vue&type=style&index=0&id=1b0e4bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e4bc4",
  null
  
)

export default component.exports